<div class="dashboard">

  <!-- Welcome row -->
  <div class="welcome-row">
    <div class="welcome-text">
      <h1 class="page-heading">Xin chào{{ userData?.name ? ', ' + userData.name : '' }}</h1>
      <p class="page-sub">Tổng quan hoạt động vận hành nền tảng DoctorCity</p>
    </div>
  </div>

  <!-- KPI tiles -->
  <div class="kpi-row">
    <div class="kpi-card">
      <div class="kpi-icon">
        <img src="assets/icons/wallet-0E7A7D.svg" alt="" width="20" height="20">
      </div>
      <div class="kpi-body">
        <div class="kpi-value">{{ userData?.diamonds ?? '—' }}</div>
        <div class="kpi-label">Kim cương</div>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--member">
        <img src="assets/icons/badge-check-0E7A7D.svg" alt="" width="20" height="20">
      </div>
      <div class="kpi-body">
        <div class="kpi-value">{{ member ? 'Thành viên' : 'Cơ bản' }}</div>
        <div class="kpi-label">Cấp độ</div>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--role">
        <img src="assets/icons/shield-alert-0E7A7D.svg" alt="" width="20" height="20">
      </div>
      <div class="kpi-body">
        <div class="kpi-value">{{ isPlatformAdmin ? 'Platform Admin' : 'Operator' }}</div>
        <div class="kpi-label">Vai trò</div>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--email">
        <img src="assets/icons/megaphone-0E7A7D.svg" alt="" width="20" height="20">
      </div>
      <div class="kpi-body">
        <div class="kpi-value kpi-value--sm">{{ userData?.email ?? '—' }}</div>
        <div class="kpi-label">Tài khoản</div>
      </div>
    </div>
  </div>

  <!-- Quick access grid — hiển thị cho mọi admin -->
  <div class="quick-section">
    <div class="section-title">Công cụ quản trị</div>
      <div class="quick-grid">
        <button class="quick-tile" (click)="navigateToQlyServices()">
          <img src="assets/icons/list-tree-0E7A7D.svg" alt="" width="20" height="20">
          <span>Danh mục dịch vụ</span>
        </button>
        <button class="quick-tile" (click)="navigateToQlyFoods()">
          <img src="assets/icons/book-open-0E7A7D.svg" alt="" width="20" height="20">
          <span>Quản lý món ăn</span>
        </button>
        <button class="quick-tile" (click)="navigateToQlyMissions()">
          <img src="assets/icons/badge-check-0E7A7D.svg" alt="" width="20" height="20">
          <span>Nhiệm vụ & Quiz</span>
        </button>
        <button class="quick-tile" (click)="navigateAdManagement()">
          <img src="assets/icons/megaphone-0E7A7D.svg" alt="" width="20" height="20">
          <span>Quảng cáo & Banner</span>
        </button>
        <button class="quick-tile" (click)="navigatePriceEditor()">
          <img src="assets/icons/sliders-horizontal-0E7A7D.svg" alt="" width="20" height="20">
          <span>Cấu hình kinh tế</span>
        </button>
        <button class="quick-tile" (click)="navigatePaymentCenter()">
          <img src="assets/icons/banknote-0E7A7D.svg" alt="" width="20" height="20">
          <span>Rút tiền & chi trả</span>
        </button>
        <button class="quick-tile" (click)="navigateControlCenter()">
          <img src="assets/icons/shield-alert-0E7A7D.svg" alt="" width="20" height="20">
          <span>Kiểm duyệt cộng đồng</span>
        </button>
        <button class="quick-tile" (click)="navigateAIManagement()">
          <img src="assets/icons/sparkles-0E7A7D.svg" alt="" width="20" height="20">
          <span>AI & Prompt</span>
        </button>
      </div>
  </div>

</div>
